import React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import "@fontsource/lexend";

const NotAcceptable = () => {
    const history = useHistory();
    const handleClick = () => {
        history.push("/");
    };
    const handleClickLogin = () => {
        history.push("/login");
    };
    return (
        <NotAcceptableStyle>
          
                <div className='not-acceptable'>
                    <h1 className=''>
                        406
                    </h1>
                    <h3 className="">
                        Thông tin chưa được xác thực. Không thể thực hiện chức năng này.
                    </h3>
                    <div className=''>
                        <div className='center'> 
                        <div className='btn-back-login' onClick={handleClick}>
                            Quay lại trang chủ
                        </div>
                        </div>
                        <div className='center'>
                     
                                <a className='btn-back-login' onClick={handleClickLogin}>
                                    <strong>Quay lại đăng nhập</strong>
                                </a> 
                       
                        </div>
                    </div>
                </div>

                        
        </NotAcceptableStyle>
    );
};
const NotAcceptableStyle = styled.div`
    font-family: "Lexend";
    font-style: normal;
    background-color: #313131;
    height: 100svh;
    box-sizing: border-box;
    display: grid;
    place-items: center;
    padding: 20px;
    h1{
        font-size: 70px;
        color: #fff;
        text-align: center;
    }
    h3{
        font-size: 20px;
        color: #06F1B9;
        text-align: center;
    }

    .btn-back-home{
        text-align: center;
        color: #fff;
    }
    .center{
        display: flex;
        justify-content: center;
    }
    .btn-back-login{
        margin-top: 15px;
        text-align: center;
        width: 170px;
        height: 42px;
        background: linear-gradient(259.14deg, #06F1B9 1.32%, #008263 100%);
        border-radius: 10px;
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        letter-spacing: -0.3px;
        color: #FFFFFF;
        display: grid;
        place-items: center;
        border: none;
        outline: none;
    }

`
export default NotAcceptable;



// WEBPACK FOOTER //
// ./src/based/406Page.js